export const DELIVERY_TYPE_OPTIONS = [
    "Staggered Batchwise",
    "Staggered partwise",
    "Common Dispatch"
];

export const GST_APPLY_OPTIONS = ["Yes", "No"];

export const GST_TYPE_OPTIONS = ["Common", "Part Wise"];

export const SCROLL_Y = 100;
